import Switch from '@/components/Switch/Switch';
import styled from '@emotion/styled';
import { useEffect, useRef, useState } from 'react';
import AiAgreementModal from './AiAgreementModal';
import UpgradePopup from './UpgradePopup';

const HoverSwitch = styled(Switch)<{ blocked: boolean }>`
    position: relative;
    overflow: visible;

    ${({ blocked }) =>
        blocked &&
        `& .MuiSwitch-input::after {
        content: '';
        position: absolute;
        width: 100%;
        height: calc(20px + 100%);
        top: -20px;
        left: 0;
        cursor: not-allowed;
    }`}
`;

interface Props {
    blocked: boolean;
    checked: boolean;
    disabled?: boolean;
    onChange: (checked: boolean) => void;
}

const RemoveWatermarkToggle = ({ blocked, checked, onChange, disabled }: Props) => {
    const switchRef = useRef<HTMLButtonElement | null>(null);
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const [mouseOnSwitch, setMouseOnSwitch] = useState(false);
    const [mouseOnPopup, setMouseOnPopup] = useState(false);
    const [agreementModalOpen, setAgreementModalOpen] = useState(false);

    useEffect(() => {
        switchRef.current?.addEventListener('mouseenter', handleSwitchMouseEnter);
        switchRef.current?.addEventListener('mouseout', handleSwitchMouseLeave);

        return () => {
            switchRef.current?.removeEventListener('mouseenter', handleSwitchMouseEnter);
            switchRef.current?.removeEventListener('mouseout', handleSwitchMouseLeave);
        };
    }, []);

    function handleSwitchMouseEnter(e: MouseEvent) {
        setAnchorEl(e.currentTarget as HTMLButtonElement);
        setMouseOnSwitch(true);
    }

    function handleSwitchMouseLeave() {
        setMouseOnSwitch(false);
    }

    function handlePopupMouseEnter() {
        setMouseOnPopup(true);
    }

    function handlePopupMouseLeave() {
        setMouseOnPopup(false);
    }

    const handleSwitchChange = (_: unknown, checked: boolean) => {
        if (blocked) {
            return;
        }
        if (!checked) {
            onChange(checked);
        } else {
            setAgreementModalOpen(true);
        }
    };

    return (
        <>
            <HoverSwitch ref={switchRef} checked={checked} onChange={handleSwitchChange} blocked={blocked} disabled={disabled} />
            <UpgradePopup
                open={blocked && (mouseOnSwitch || mouseOnPopup)}
                anchorEl={anchorEl}
                onMouseEnter={handlePopupMouseEnter}
                onMouseLeave={handlePopupMouseLeave}
            />
            <AiAgreementModal
                open={agreementModalOpen}
                onClose={() => {
                    setAgreementModalOpen(false);
                }}
                onRemoveWatermark={() => {
                    onChange(true);
                }}
            />
        </>
    );
};

export default RemoveWatermarkToggle;
